import BaseInputTextInline from "./BaseInputTextInline.vue";

export default BaseInputTextInline;
